import { get, put, post, destroy } from '../../utils/fetch'

const updateKeys = [
  'id',
  'transcodeId',
  'title',
  'coverartURL',
  'description',
  'tags',
  'lyrics',
  'genre',
  'sales',
  'price',
  'nameyourprice',
  'status',
  'license',
  'licensecode',
  'ccType',
  'sampling',
  'limit',
  'limitFrom',
  'limitTo',
]

const stripByKeys = (keys, data) => {
  const result = {}
  keys.forEach((key) => {
    if (
      data[key] !== undefined
      || data[key] !== null
    ) {
      result[key] = data[key]
    }
  })
  return result
}

export const getSound = (id: string) => {
  const sound = get(`/sounds/${id}`)
  return sound
}

export const getMySounds = (page = 1, perPage = 20, token: string = null) => {
  const sound = get(`/sounds/my?page=${page}&perPage=${perPage}`, { token })
  return sound
}

export const createSounds = (data) => {
  const sounds = data.map((sound) => stripByKeys(updateKeys, sound))
  const sound = post('/sounds/', { sounds })
  return sound
}

export const updateSound = (data) => {
  const sound = put(`/sounds/${data.id}`, data)
  return sound
}

export const getSoundLikes = async (id) => ({ id })

export const playSound = async (id: string) => {
  const result = post(`/sounds/${id}/play`)
  return result
}

export const likeSound = (id: string, count: number) => {
  const result = post(`/sounds/${id}/like`, { count })
  return result
}

export const clapSound = (id: string, times: number) => {
  const result = post(`/clap/sound/${id}`, { times })
  return result
}

export const getTagSound = (
  tag: string,
  category = 'released',
  page = 1,
  perPage = 3,
) => {
  const result = get(
    `/sounds/${tag}/tag?category=${category}&page=${page}&perPage=${perPage}`,
  )
  return result
}

export const deleteSound = (id: string) => {
  const result = destroy(`/sounds/${id}`)
  return result
}
